import { render, staticRenderFns } from "./StatItemCard.vue?vue&type=template&id=3fe4de49&scoped=true&"
import script from "./StatItemCard.vue?vue&type=script&lang=js&"
export * from "./StatItemCard.vue?vue&type=script&lang=js&"
import style0 from "./StatItemCard.vue?vue&type=style&index=0&id=3fe4de49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe4de49",
  null
  
)

export default component.exports